import React from 'react';
import { cn } from '@/lib/utils';

type ContainerCountCellProps = {
  amountOfBoxes: number;
  amountOfContainers: number;
  className?: string;
};

export const ContainerCountCell: React.FC<ContainerCountCellProps> = ({
  amountOfBoxes,
  amountOfContainers,
  className = '',
}) => {
  if (amountOfContainers === 0 && amountOfBoxes === 0) {
    return <div className={cn('tw:text-muted-foreground', className)}>-</div>;
  }

  return (
    <div className={cn('tw:gap-1', className)}>
      <span className="tw:text-sm tw:font-medium tw:text-foreground">
        {amountOfContainers}
      </span>
      <br />
      {amountOfBoxes > 0 && (
        <span className="tw:text-xs tw:text-muted-foreground">
          {amountOfBoxes} {amountOfBoxes === 1 ? 'box' : 'boxes'}
        </span>
      )}
    </div>
  );
};
